export default __webpack_public_path__ + "e69a06cff38b0f9fd4a0b884f05450d8.png";